<template>
  <Selector
    :title="'Location'"
    :items="userLocations"
    @setLocation="setLocation"
  />
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import uiHelper from '@/helpers/ui'
import Selector from '@/components/Selector'

export default {
  name: 'Location',

  components: {
    Selector
  },

  computed: {
    ...mapGetters({
      userLocations: 'user/userLocations',
      selectedBusinessId: 'user/selectedBusinessId'
    })
  },

  async created() {
    uiHelper.progressBarStatus(true)
    try {
      await this.getAllLocations()
      if (this.userLocations.length === 1) await this.setLocation()
      await this.getBusinessDetails(this.selectedBusinessId)
    } catch (error) {
      uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
    }
    uiHelper.progressBarStatus(false)
  },

  methods: {
    ...mapActions({
      createUnoappRespondent: 'user/createUnoappRespondent',
      getPermissions: 'user/getMyPermissions',
      getMyForms: 'form/getMyForms',
      getBusinessDetails: 'business/getBusinessDetails',
      getAllLocations: 'user/getAllLocations',
      setActiveLocation: 'user/setActiveLocation'
    }),
    ...mapMutations({
      setSelectedLocation: 'user/setSelectedLocation'
    }),

    async setLocation(location = this.userLocations[0]) {
      uiHelper.progressBarStatus(true)
      let res = await this.setActiveLocation(location)
      if (!res) {
        uiHelper.progressBarStatus(false)
        throw new Error('Error setting location')
      }
      // let publicForms

      // publicForms = await this.getMyForms(true)
      let formsRes = await this.getMyForms(false)
      if (!formsRes) {
        uiHelper.progressBarStatus(false)
        throw new Error('Error getting forms')
      }
      // if (privateForms) {
      this.$router.push({ name: 'Dashboard' })
      // }
    }
  }
}
</script>
